import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Text,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  IconButton,
  Spinner,
  Select,
  Icon,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { FaCircle, FaAlignJustify, FaArrowLeft, FaSync } from "react-icons/fa";
import { HamburgerIcon } from "@chakra-ui/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import moment from "moment";
import ListaBoletoAPI from "../../../services/ListaBoleto";
import VendasBolePixLoteApi from "../../../services/VendasBoletoloteApi";
import SystemApi from "../../../services/systemApi";
import PermissionsAPI from "../../../services/permissionsAPI";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import { dadosDoToken } from "../../../defaultFunctions/token";
import { componentState } from "../../../atoms/componentState";
import { LoggedUser } from "../../../atoms/userLogged";
import { customColors } from "../../../atoms/customColors";
import { permissions } from "../../../atoms/permissions";
import Pagination from "../../../defaultComponents/pagination";
import DateDropdownDeafult from "../../../defaultComponents/dateDropdown";
import ModalDetailVendaBoleto from "./components/ModalDetailVendaBoleto";
import LoteStatusProgresso from "./components/LoteStatusProgresso";

interface objetoSalesList {
  id: string;
  idCliente: number;
  bandeira: string;
  clienteNome: string | null;
  cnpj: string;
  dataCriacao: string;
  dataExpiracao: string | null;
  dataPagamento: string | null;
  isCnpj: boolean;
  nomeFantasia: string;
  razaoSocial: string;
  status: string;
  taxaCliente: number;
  taxaPlano: number;
  valor: number;
  valorLiquido: number;
  barcode?: string;
  emv?: string;
  mensagem?: string;
  idLote?: string;
  // id da transação na Zoop; nulo enquanto a parcela não foi emitida.
  // Emissão de ensaio vem com o prefixo MOCK-.
  idTransacao?: string | null;
  // prazo em que o banco ainda aceita o pagamento depois do vencimento
  dataLimitePagamento?: string | null;
  // Numero da parcela dentro do carne (1..N). Vem da propria linha de Bolepix.
  parcela?: number | null;
  // dados do pagador e do EC, que a modal de detalhe exibe
  nomePagador?: string;
  cpfPagador?: string;
  emailPagador?: string;
  telefone?: string;
}

interface statusInfo {
  id: number;
  status: string;
}

interface JWTToken {
  primarysid: string;
  name: string;
  email: string;
  exp: number;
  idCliente: number;
  loginPermissoes: string;
}


const STATUS_PENDENTE_EMITIDO = "pendente_emitido";

export default function BatchBoletosList() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [salesList, setSalesList] = useState<objetoSalesList[]>([]);
  // id da parcela sendo reemitida, para travar só aquele item do menu
  const [reemitindo, setReemitindo] = useState<string | null>(null);
  // Trava SÍNCRONA da reemissão. O estado acima só desabilita o item depois do
  // re-render, e o menu fecha no clique: dois cliques rápidos (ou reabrir o
  // menu e clicar de novo) disparavam duas emissões da MESMA parcela, ou seja,
  // duas cobranças. O ref é lido e escrito no mesmo tick, antes de qualquer
  // await.
  const reemitindoRef = useRef<string | null>(null);
  // Quantas parcelas o carnê tem no total, para a coluna mostrar "2/6" em vez
  // de um "2" solto. Vem do endpoint de status, que devolve o carnê inteiro —
  // contar o que está na tela daria errado se a listagem for paginada.
  const [totalParcelas, setTotalParcelas] = useState<number>(0);

  // Desconto por parcela. A view vw_Bolepix não conhece as regras do lote, e o
  // valor do boleto sozinho não é o que o pagador quita quando antecipa — quem
  // sabe disso é o endpoint de status do lote, que já aplica a mesma regra da
  // emissão (a 1ª parcela só entra se o lote foi criado com "desconto na 1ª").
  const [descontos, setDescontos] = useState<
    Record<string, { desconto: number; valorComDesconto: number; descontoAte: string | null }>
  >({});
  const [resumoDesconto, setResumoDesconto] = useState<any>(null);
  const [openDetails, setOpenDetails] = useState(false);
  const [details, setDetails] = useState<objetoSalesList | {}>({});
  const [statusList, setStatusList] = useState<statusInfo[]>([]);
  const [permissionsList, setPermissionsList] = useState<Array<any>>([]);
  const [isNotEmpty, setIsNotEmpty] = useState(false);
  const safeDate = (date?: string): string => date || "";
  const fmtBRL = (n: number) =>
    (Number.isFinite(n) ? n : 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  const [colors] = useRecoilState(customColors);
  const [user] = useRecoilState(LoggedUser);
  const setPermsRecoil = useSetRecoilState(permissions);
  const token = window.localStorage.getItem("token");
  const jwtToken = dadosDoToken(token) as unknown as JWTToken;
  const navigate = useNavigate();
  const setHeaderLocation = useSetRecoilState(componentState);
  const { idLote } = useParams<{ idLote: string }>();

  const initialValues = {
    statusFilter: 0 as number | string,
    initialDateFilter: "",
    finalDateFilter: "",
    minValueFilter: 0,
    maxValueFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);

  async function fetchPermissions(id: string) {
    try {
      const response = await PermissionsAPI.getPermissions(id);
      setPermissionsList(response);
      setPermsRecoil(response);
      setIsNotEmpty(response.length > 0);
    } catch (error) {
      console.error("Error fetching permissions:", error);
      toast.error("Erro ao carregar permissões!");
    }
  }

  let loginPermissoes: number[] = [];
  if (token && typeof token === "string" && token.includes(".")) {
    try {
      const decoded: JWTToken = jwt_decode(token);
      if (decoded.loginPermissoes) {
        loginPermissoes = JSON.parse(decoded.loginPermissoes);
      }
    } catch (error) {
      console.error("Error decoding JWT or parsing loginPermissoes:", error);
    }
  }

  useEffect(() => {
    if (permissionsList.length === 0 && !isNotEmpty && jwtToken.idCliente) {
      fetchPermissions(String(jwtToken.idCliente));
    }
  }, [permissionsList, jwtToken.idCliente]);

  function temPermissao(
    userPerm: number | null,
    clientePerm: boolean,
    permArray: number[] = []
  ): boolean {
    if (!permArray.length || userPerm === null) {
      return clientePerm ?? false;
    }
    const permUser = permArray.includes(userPerm);
    const permCliente = clientePerm ?? false;
    return permUser && permCliente;
  }

  const hasBolePixPermission = temPermissao(
    44,
    permissionsList.some((perm: any) => perm.idPermissoes === 44),
    loginPermissoes
  );

  // Reemissão manual: para quando a parcela falhou e o runner já desistiu
  // (5 tentativas por parcela). A core remonta o payload do zero a partir do
  // banco, então não há nada para preencher aqui — só disparar e recarregar.
  async function reemitirParcela(idBoleto: string) {
    // já existe uma emissão em andamento (desta ou de outra parcela): ignora
    if (reemitindoRef.current) return;

    reemitindoRef.current = idBoleto;
    setReemitindo(idBoleto);

    try {
      const retorno = await ListaBoletoAPI.reemitirParcela(idBoleto);
      toast.success(
        `Parcela emitida${retorno?.idTransacao ? ` (${retorno.idTransacao})` : ""}.`
      );
      await getBoletosByLote();
    } catch (erro: any) {
      const dados = erro?.response?.data;
      // a core devolve o motivo real (etapa, retorno do provedor); genérico só
      // quando não vier nada
      const motivo =
        (typeof dados === "string" && dados) ||
        dados?.motivo ||
        dados?._error ||
        "Não foi possível emitir a parcela.";
      toast.error(motivo);
    } finally {
      reemitindoRef.current = null;
      setReemitindo(null);
    }
  }

  async function getBoletosByLote() {
    if (!idLote) {
      toast.error("ID do lote não fornecido!");
      return;
    }
    try {
      setLoading(true);
      const response = await ListaBoletoAPI.getBolepix(
        currentPage,
        pageSize,
        Number(jwtToken.idCliente),
        search,
        filtros.minValueFilter,
        filtros.maxValueFilter,
        filtros.statusFilter === STATUS_PENDENTE_EMITIDO
          ? 0
          : Number(filtros.statusFilter),
        5,
        false,
        undefined,
        undefined,
        idLote,
        undefined,
        undefined,
        undefined,
        safeDate(filtros.initialDateFilter),
        safeDate(filtros.finalDateFilter),
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        filtros.statusFilter === STATUS_PENDENTE_EMITIDO ? "pendente" : undefined
      );

      const mappedSales: objetoSalesList[] = response.data.map((item: any) => ({
        id: item.id,
        idCliente: item.idCliente,
        bandeira: item.transacao?.bandeira || "-",
        clienteNome: item.transacao?.clienteNome || item.eC_RazaoSocial || "-",
        // o documento do EC vem do próprio boleto; a transação pode nem existir
        cnpj: item.transacao?.cnpj || item.eC_Cnpj || "-",
        dataCriacao: item.transacao?.dataCriacao || item.criadoEm || "",
        dataExpiracao:
          item.transacao?.dataExpiracao || item.dataVencimento || null,
        dataPagamento: item.transacao?.dataPagamento || null,
        isCnpj: item.transacao?.isCnpj ?? item.eC_IsCnpj ?? false,
        // Sem transação (parcela não emitida, ou emitida em ensaio) não há EC
        // vindo da Zoop — mas a view já traz os dados do estabelecimento.
        nomeFantasia: item.transacao?.nomeFantasia || item.eC_NomeFantasia || "",
        razaoSocial:
          item.transacao?.razaoSocial || item.eC_RazaoSocial || jwtToken.name || "-",
        // Status CRU da view; quem traduz é situacaoParcela(), que também olha
        // barcode e dataPagamento. A expressão antiga era `a || b ? x : y`, que
        // por precedência ignorava o status e só perguntava se havia
        // idTransacao — parcela paga continuava aparecendo como "Boleto Gerado".
        status: item.status || "",
        taxaCliente: item.transacao?.taxaCliente || 0,
        taxaPlano: item.transacao?.taxaPlano || 0,
        valor:
          item.transacao?.valor ||
          parseFloat(item.valor?.replace(",", ".")) ||
          0,
        valorLiquido: item.transacao?.valorLiquido || 0,
        idTransacao: item.idTransacao || null,
        dataLimitePagamento: item.dataLimitePagamento || null,
        nomePagador: item.nomePagador || "",
        cpfPagador: item.cpfPagador || "",
        emailPagador: item.emailPagador || "",
        telefone: item.numeroPagador || "",
        barcode: item.barcode || "",
        emv: item.emv || "",
        mensagem: item.mensagem || "",
        idLote: item.idLote || idLote,
        parcela: item.parcela ?? null,
      }));

      setSalesList(mappedSales);
      setPages(
        Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
      );
    } catch (error) {
      console.error("Error fetching boletos by lote:", error);
      toast.error("Erro ao carregar a lista de boletos do lote!");
    } finally {
      setLoading(false);
    }
  }

  async function getDescontosDoLote() {
    if (!idLote) return;
    try {
      const data = await VendasBolePixLoteApi.getStatusLote(idLote);
      const mapa: Record<string, any> = {};
      setTotalParcelas((data?.parcelas || []).length);
      (data?.parcelas || []).forEach((p: any) => {
        mapa[p.id] = {
          desconto: Number(p.desconto) || 0,
          valorComDesconto: Number(p.valorComDesconto) || 0,
          descontoAte: p.descontoAte || null,
        };
      });
      setDescontos(mapa);
      setResumoDesconto(
        data?.descontoRegra
          ? {
            ...data.descontoRegra,
            totalBruto: Number(data.totalBruto) || 0,
            totalDesconto: Number(data.totalDesconto) || 0,
            totalComDesconto: Number(data.totalComDesconto) || 0,
          }
          : null
      );
    } catch (error) {
      // sem desconto na tela é degradação aceitável — a lista continua de pé
      console.error("Erro ao carregar descontos do lote:", error);
    }
  }

  async function getStatusList() {
    try {
      const response = await SystemApi.getTransacoesStatus();
      setStatusList(response);
    } catch (error) {
      console.error("Error fetching status list:", error);
    }
  }

  useEffect(() => {
    setHeaderLocation(`Boletos do Lote ${idLote || ""}`);
    getStatusList();
    getDescontosDoLote();
  }, []);

  useEffect(() => {
    getBoletosByLote();
  }, [
    idLote,
    search,
    currentPage,
    pageSize,
    filtros.statusFilter,
    filtros.initialDateFilter,
    filtros.finalDateFilter,
    filtros.minValueFilter,
    filtros.maxValueFilter,
  ]);

  const statusOptions = [
    {
      key: STATUS_PENDENTE_EMITIDO,
      value: STATUS_PENDENTE_EMITIDO,
      text: "Pendente (emitido)",
    },
    ...statusList
      .filter((item) => item.status.toLowerCase() === "sucesso")
      .map((item) => ({
        key: item.id,
        value: item.id,
        text: "Sucesso",
      })),
  ];

  const onChangeStatusFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFiltros({ ...filtros, statusFilter: e.target.value || 0 });
    setCurrentPage(1);
  };

  const onChangeSize = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPageSize(Number(e.target.value));
    setCurrentPage(1);
  };

  /**
   * Situação REAL da parcela, derivada dos dados — não do status da Transacao.
   *
   * Parcela sem emissão não tem transação, então `status` vem vazio e virava
   * "A ser gerado" tanto para a que ainda não foi emitida quanto para a que
   * falhou; e a parcela PAGA aparecia como "Boleto Gerado". O que responde à
   * pergunta de quem cobra é: saiu o boleto? foi pago?
   */
  const situacaoParcela = (item: {
    barcode?: string;
    status?: string;
    dataPagamento?: string | null;
  }): { texto: string; cor: string } => {
    if (!item.barcode) return { texto: "Não emitido", cor: colors.REDMONEDD };

    // `dataPagamento` NÃO decide sozinha. Ela vem preenchida com a data de
    // VENCIMENTO em transações `pending` (medido: 10 boletos assim no 234, todos
    // em aberto), e a regra antiga — que perguntava por ela antes do status —
    // exibia esses boletos como "Pago". Quem manda é o status; a data só
    // confirma quando ele não disser o contrário.
    switch ((item.status || "").toLowerCase()) {
      case "paid":
      case "succeeded":
        return { texto: "Pago", cor: colors.GREENMONEDD };
      case "pending":
        return { texto: "Emitido · aguardando pagamento", cor: colors.YELLOWMONEDD };
      case "expired":
        return { texto: "Expirado", cor: colors.ORANGEMONEDD };
      case "canceled":
      case "cancelled":
        return { texto: "Cancelado", cor: colors.GRAY };
      // emitido mas sem Transacao importada no M2
      case "":
        return item.dataPagamento
          ? { texto: "Pago", cor: colors.GREENMONEDD }
          : { texto: "Emitido", cor: colors.YELLOWMONEDD };
      default:
        return { texto: item.status!, cor: colors.GRAY };
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "succeeded":
        return colors.GREENMONEDD;
      case "pending":
        return colors.YELLOWMONEDD;
      case "failed":
        return colors.ORANGEMONEDD;
      case "new":
        return colors.GRAYCARD;
      case "chargeback":
        return colors.REDCARD;
      case "canceled":
        return colors.REDMONEDD;
      case "generated":
        return colors.YELLOWMONEDD;
      default:
        return colors.GRAY;
    }
  };

  const renderTable = () => (
    <TableContainer
      maxWidth="100%"
      overflowX="auto"
      overflowY="auto"
      maxHeight="55vh"
    >
      <Table
        variant="simple"
        size="md"
        colorScheme="gray"
        width="100%"
        minWidth="1600px"
      >
        <Thead>
          <Tr>
            {/* Numero da parcela: sem ele a lista do carne e um monte de linha
                igual, e o operador nao sabe qual delas esta olhando. */}
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              borderTopLeftRadius="md"
              minWidth="90px"
              whiteSpace="nowrap"
              textAlign="center"
            >
              Parcela
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="120px"
              whiteSpace="nowrap"
            >
              Data
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="150px"
              whiteSpace="nowrap"
            >
              EC
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="120px"
              whiteSpace="nowrap"
            >
              Status
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="120px"
              whiteSpace="nowrap"
            >
              Vencimento
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="140px"
              whiteSpace="nowrap"
            >
              Limite p/ pagamento
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="180px"
              whiteSpace="nowrap"
            >
              ID Transação
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="100px"
              whiteSpace="nowrap"
            >
              Valor Total
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="110px"
              whiteSpace="nowrap"
            >
              Desconto
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="150px"
              whiteSpace="nowrap"
            >
              Valor c/ desconto
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              borderTopRightRadius="md"
              minWidth="80px"
              whiteSpace="nowrap"
              position="sticky"
              right={0}
              zIndex={1}
              bg={colors.BLUEMONEDDBACKGROUND}
            >
              Opções
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {salesList.length === 0 ? (
            <Tr>
              <Td colSpan={11} textAlign="center">
                Nenhum boleto encontrado
              </Td>
            </Tr>
          ) : (
            salesList.map((item, index) => (
              <Tr
                key={index}
                _hover={{ bg: colors.GRAY_LIGHTEST }}
                transition="background 0.2s"
              >
                <Td whiteSpace="nowrap" textAlign="center" fontWeight="semibold">
                  {item.parcela
                    ? `${item.parcela}${
                        totalParcelas ? `/${totalParcelas}` : ""
                      }`
                    : "-"}
                </Td>
                <Td whiteSpace="nowrap">
                  {item.dataCriacao
                    ? moment(item.dataCriacao).format("DD/MM/YYYY HH:mm")
                    : "-"}
                </Td>
                <Td whiteSpace="nowrap">
                  {item.isCnpj
                    ? item.razaoSocial || "-"
                    : `${item.razaoSocial || "-"} ${item.nomeFantasia || ""}`}
                </Td>
                <Td whiteSpace="nowrap">
                  <Flex alignItems="center">
                    <Icon
                      as={FaCircle}
                      color={situacaoParcela(item).cor}
                      boxSize={3}
                      mr={2}
                    />
                    {situacaoParcela(item).texto}
                  </Flex>
                </Td>
                <Td whiteSpace="nowrap">
                  {item.dataExpiracao
                    ? moment(item.dataExpiracao).format("DD/MM/YYYY")
                    : "-"}
                </Td>
                <Td whiteSpace="nowrap">
                  {item.dataLimitePagamento
                    ? moment(item.dataLimitePagamento).format("DD/MM/YYYY")
                    : "-"}
                </Td>
                {/* inteiro e clicável: o id só tem uso colado num chamado, e um
                    pedaço dele não abre nada. O nome do provedor não aparece
                    para o cliente — ele contrata a Monedd. */}
                <Td
                  whiteSpace="nowrap"
                  fontFamily="monospace"
                  fontSize="xs"
                  cursor={item.idTransacao ? "pointer" : "default"}
                  title={item.idTransacao ? "Clique para copiar" : ""}
                  _hover={item.idTransacao ? { textDecoration: "underline" } : undefined}
                  onClick={() => {
                    if (!item.idTransacao) return;
                    navigator.clipboard?.writeText(item.idTransacao);
                    toast.info("ID da transação copiado.");
                  }}
                >
                  {item.idTransacao || "-"}
                </Td>
                <Td whiteSpace="nowrap">
                  {(item.valor ?? 0).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </Td>
                <Td whiteSpace="nowrap" color={colors.GREENMONEDD}>
                  {descontos[item.id]?.desconto
                    ? `- ${fmtBRL(descontos[item.id].desconto)}`
                    : "—"}
                </Td>
                <Td whiteSpace="nowrap">
                  {descontos[item.id]?.desconto ? (
                    <>
                      <Text fontWeight="semibold">
                        {fmtBRL(descontos[item.id].valorComDesconto)}
                      </Text>
                      {descontos[item.id].descontoAte && (
                        <Text fontSize="xs" color={colors.GRAY_DARK}>
                          se pago até{" "}
                          {moment(descontos[item.id].descontoAte).format(
                            "DD/MM/YYYY"
                          )}
                        </Text>
                      )}
                    </>
                  ) : (
                    "—"
                  )}
                </Td>
                <Td
                  whiteSpace="nowrap"
                  position="sticky"
                  right={0}
                  zIndex={1}
                  bg={colors.WHITE}
                >
                  <Menu>
                    <MenuButton
                      as={IconButton}
                      aria-label="Options"
                      icon={<HamburgerIcon />}
                      bgColor={colors.BLUEMONEDDBUTTONS}
                      color={colors.WHITE}
                      size="sm"
                      _hover={{ bgColor: colors.BLUEMONEDDRGB2 }}
                      _active={{ bgColor: colors.BLUEMONEDDBACKGROUND }}
                      transition="all 0.2s"
                    />
                    <MenuList>
                      <MenuItem
                        onClick={() => {
                          setOpenDetails(true);
                          // o modal recebe o rótulo já resolvido: senão a linha
                          // diria "Pago" e o detalhe dela, outra coisa
                          setDetails({ ...item, status: situacaoParcela(item).texto });
                        }}
                        _hover={{ bg: colors.GRAY_LIGHT }}
                      >
                        <Flex alignItems="center">
                          Visualizar Detalhes
                          <Icon
                            as={FaAlignJustify}
                            color={colors.BLUEMONEDDBUTTONS}
                            boxSize={4}
                            ml={2}
                          />
                        </Flex>
                      </MenuItem>

                      {/* Só faz sentido para parcela que ainda não virou boleto:
                          com transação existente, reemitir cobraria duas vezes. */}
                      {!item.idTransacao && (
                        <MenuItem
                          isDisabled={reemitindo !== null}
                          onClick={() => reemitirParcela(item.id)}
                          _hover={{ bg: colors.GRAY_LIGHT }}
                        >
                          <Flex alignItems="center">
                            {reemitindo === item.id
                              ? "Emitindo..."
                              : "Tentar emitir novamente"}
                            <Icon
                              as={FaSync}
                              color={colors.BLUEMONEDDBUTTONS}
                              boxSize={3.5}
                              ml={2}
                            />
                          </Flex>
                        </MenuItem>
                      )}
                    </MenuList>
                  </Menu>
                </Td>
              </Tr>
            ))
          )}
        </Tbody>
      </Table>
    </TableContainer>
  );

  return (
    <Flex
      flexDir="column"
      height="90vh"
      width="100%"
      bgColor={colors.GRAY_LIGHTEST}
      p={8}
      overflow="hidden"
    >
      <Box mb={8} bg={colors.WHITE} borderRadius="lg" boxShadow="md" p={6}>
        <Flex alignItems="center" mb={6}>
          <Button
            bgColor="transparent"
            color={colors.BLUEMONEDDBUTTONS}
            size="md"
            onClick={() => navigate("/vendas/bolepix")}
            leftIcon={<FaArrowLeft />}
            _hover={{ color: colors.BLUEMONEDDRGB2 }}
            transition="all 0.2s"
            mr={3}
          >
            Voltar
          </Button>
          <Text
            fontSize="3xl"
            fontWeight="bold"
            color={colors.BLUEMONEDDBACKGROUND}
          >
            Boletos do Lote {idLote || ""}
          </Text>
        </Flex>
        <Flex flexWrap="wrap" gap={4} alignItems="center">
          <Select
            placeholder="Filtrar por Status"
            maxW="250px"
            value={filtros.statusFilter}
            onChange={onChangeStatusFilter}
            bg={colors.WHITE}
            borderColor={colors.GRAY_LIGHTER}
            _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
            _hover={{ borderColor: colors.BLUEMONEDDRGB2 }}
          >
            {statusOptions.map((item) => (
              <option value={item.value} key={item.key}>
                {item.text}
              </option>
            ))}
          </Select>
          <DateDropdownDeafult
            filtros={filtros}
            setFiltros={setFiltros}
            label="Vencimento"
            futurePresets
          />
          <Button
            bgColor={colors.GRAY_DARK}
            color={colors.WHITE}
            size="md"
            onClick={() => setFiltros(initialValues)}
            _hover={{ bgColor: colors.GRAY_DARKEST }}
            _active={{ bgColor: colors.GRAY_DARKER }}
            transition="all 0.2s"
          >
            Limpar Filtros
          </Button>
        </Flex>
      </Box>

      {idLote && (
        <Box mb={6} bg={colors.WHITE} borderRadius="lg" boxShadow="md" p={6}>
          <Text
            fontSize="lg"
            fontWeight="bold"
            color={colors.BLUEMONEDDBACKGROUND}
            mb={3}
          >
            Progresso da Geração
          </Text>
          {/* Quando a geração termina, recarrega a tabela abaixo: ela não tem
              polling próprio e ficava mostrando "Não emitido" nas parcelas que
              o painel já contabilizava como emitidas. */}
          <LoteStatusProgresso
            idLote={idLote}
            compact
            onConcluido={() => getBoletosByLote()}
          />
        </Box>
      )}

      {/* Com desconto, o total do carnê tem dois números: o que está impresso
          nos boletos e o que o pagador quita se antecipar todas as parcelas. */}
      {resumoDesconto && (
        <Box
          mb={4}
          bg={colors.WHITE}
          borderRadius="lg"
          boxShadow="md"
          p={4}
          borderLeftWidth="4px"
          borderLeftColor={colors.GREENMONEDD}
        >
          <Flex justify="space-between" flexWrap="wrap" gap={3}>
            <Box>
              <Text fontSize="sm" fontWeight="bold" color={colors.BLUEMONEDDBACKGROUND}>
                Desconto por antecipação
              </Text>
              <Text fontSize="sm">
                {resumoDesconto.ehPercentual
                  ? `${Number(resumoDesconto.valor)
                    .toFixed(2)
                    .replace(".", ",")}% de cada parcela`
                  : `${fmtBRL(Number(resumoDesconto.valor))} por parcela`}
                {resumoDesconto.diasAntesVencimento > 0
                  ? ` · até ${resumoDesconto.diasAntesVencimento} dia(s) antes do vencimento`
                  : " · até o vencimento"}
                {resumoDesconto.naPrimeiraParcela
                  ? " · vale também na 1ª parcela"
                  : " · não vale na 1ª parcela"}
              </Text>
            </Box>
            <Flex gap={6} flexWrap="wrap">
              <Box>
                <Text fontSize="xs" color={colors.GRAY_DARK}>
                  Total dos boletos
                </Text>
                <Text fontWeight="bold">
                  {fmtBRL(resumoDesconto.totalBruto)}
                </Text>
              </Box>
              <Box>
                <Text fontSize="xs" color={colors.GRAY_DARK}>
                  Desconto total
                </Text>
                <Text fontWeight="bold" color={colors.GREENMONEDD}>
                  - {fmtBRL(resumoDesconto.totalDesconto)}
                </Text>
              </Box>
              <Box>
                <Text fontSize="xs" color={colors.GRAY_DARK}>
                  Total antecipando tudo
                </Text>
                <Text fontWeight="bold" color={colors.BLUEMONEDDBUTTONS}>
                  {fmtBRL(resumoDesconto.totalComDesconto)}
                </Text>
              </Box>
            </Flex>
          </Flex>
        </Box>
      )}

      <Box
        flex="1"
        bg={colors.WHITE}
        borderRadius="lg"
        boxShadow="md"
        p={6}
        overflow="visible"
      >
        {loading ? (
          <Flex h="50vh" alignItems="center" justifyContent="center">
            <Spinner
              size="xl"
              color={colors.BLUEMONEDDBUTTONS}
              thickness="4px"
            />
          </Flex>
        ) : (
          renderTable()
        )}

        {/* Emissão em andamento: o menu já fechou no clique, então sem este
            aviso a tela fica idêntica e o operador clica de novo — cada clique
            é uma cobrança. Cobre o conteúdo e bloqueia o mouse até terminar. */}
        {reemitindo && (
          <Flex
            position="fixed"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bg="blackAlpha.500"
            zIndex={1500}
            alignItems="center"
            justifyContent="center"
            direction="column"
            gap={3}
          >
            <Spinner size="xl" color={colors.WHITE} thickness="4px" />
            <Text color={colors.WHITE} fontWeight="bold">
              Emitindo parcela…
            </Text>
            <Text color={colors.WHITE} fontSize="sm">
              Não feche a tela — emitir duas vezes gera duas cobranças.
            </Text>
          </Flex>
        )}
        <Flex justifyContent="center" alignItems="center" mt={6} gap={4}>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pages={pages}
            pageSize={pageSize}
          />
          <Select
            value={pageSize}
            onChange={onChangeSize}
            size="sm"
            width="80px"
            bg={colors.WHITE}
            borderColor={colors.GRAY_LIGHTER}
            _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
            _hover={{ borderColor: colors.BLUEMONEDDRGB2 }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={25}>25</option>
          </Select>
        </Flex>
        <ModalDetailVendaBoleto
          isOpen={openDetails}
          setIsOpen={setOpenDetails}
          item={details}
        />
      </Box>
    </Flex>
  );
}
